import React, { useContext } from "react";
import GlobalContext from "../../../Contexts/Global/GlobalContext";
import VisualizationStepSelectYourData from "../../../assets/Visualize/BrandStarter/VisualizationStepSelectYourData.svg";
import VisualizationStepCreateAReport from "../../../assets/Visualize/BrandStarter/VisualizationStepCreateAReport.svg";
import VisualizationStepDownloadTheReport from "../../../assets/Visualize/BrandStarter/VisualizationStepDownloadTheReport.svg";
import HeroBackgroundVideo from "./HeroBackgroundVideo";
import {
    PageWrapper,
    HeroSection,
    HeroInner,
    HeroTitle,
    HeroSubtext,
    HeroWelcome,
    Section,
    HearFromYouTitle,
    OfferingsGrid,
    MetricsSection,
    MetricItem,
    BenefitsGrid,
    BenefitCard,
    WhyGrid,
    WhyCard,
    HearFromYouSection,
    HearFromYouInner,
    HearFromYouText,
    FooterArea,
    FooterBlock,
} from "./LandingPage.styles";

const OFFERINGS = [
    {
        title: "Financial Advisor Customer Experience Survey",
        description:
            "Detailed survey insight from financial advisors, wealth, and personal asset managers to reveal key customer experience dimensions.",
        image: VisualizationStepSelectYourData,
    },
    {
        title: "Global Asset Management Survey",
        description:
            "In-depth understanding economic benchmarks, survey, business, and business performance to identify growth opportunities.",
        image: VisualizationStepCreateAReport,
    },
    {
        title: "Global Growth Cube",
        description:
            "Comprehensive market sizing database of growth opportunities by geography, client segment, and product.",
        image: VisualizationStepDownloadTheReport,
    },
];

const BENEFITS = [
    "Identify implications of positive customer experience to deliver long-term impact.",
    "Benchmark capabilities to increase market share against peers and find opportunities to drive growth and improve profitability.",
    "Improve strategic growth and resource allocation decisions.",
];

const WHY_ITEMS = [
    {
        title: "Comprehensive data",
        description:
            "With 2023, it combines the data from ~covering 80% of global AUM and granular client insights for 100+ entities by client segment and asset class. Performance Lens provides the most comprehensive view of the asset management industry for more than 20 years of data.",
    },
    {
        title: "Deep expertise",
        description:
            "Performance Lens leverages the expertise of a dedicated team of individuals focused exclusively on asset management. McKinsey's 40+ years of consulting experience and deep market expertise across all client types.",
    },
    {
        title: "Flexible delivery service model",
        description:
            "Performance Lens delivers insights through a range of services including subscriptions, workshops, client diagnostics and other custom analytics, and including McKinsey engagement units.",
    },
];

const LandingPage = () => {
    const { firstName } = useContext(GlobalContext);
    return (
        <PageWrapper>
            <HeroSection>
                <HeroBackgroundVideo />
                <HeroInner>
                <HeroWelcome>
                    Hi {firstName}
                </HeroWelcome>
                <HeroTitle>
                    <span>Welcome to Performance Lens</span>
                    <span>Global Growth Cube</span>
                </HeroTitle>
                <HeroSubtext>McKinsey's comprehensive market-sizing database of growth opportunities by geography, client segment, and product</HeroSubtext>
                </HeroInner>
            </HeroSection>

            <HearFromYouSection>
                    <HearFromYouTitle>We want to hear from you!</HearFromYouTitle>
                    <HearFromYouText>
                    If you have any questions or feedback, please feel free to contact our team at{" "}
                    <a href="mailto:performancelens_growthcube@mckinsey.com">
                    performancelens_growthcube@mckinsey.com
                    </a>{" "}.
                    </HearFromYouText>
            </HearFromYouSection>
            {/* <AdditionalResources /> */}

            <FooterArea>
                <FooterBlock />
            </FooterArea>
        </PageWrapper>
    );
};

export default LandingPage;
